import {Component, Input, OnInit} from '@angular/core';

declare let $;

@Component({
  selector: 'app-dev-ex-service-manager',
  templateUrl: './dev-ex-service-manager.component.html',
  styleUrls: ['./dev-ex-service-manager.component.scss']
})
export class DevExServiceManagerComponent implements OnInit {

  @Input() devExServicesPayload: any;
  availableDevExServices = [];

  devExUtilities = [
    {
      'displayName': 'DevEx Portal',
      'image': './assets/img/partnerOnboarding/portal.png',
      'description': 'Manage your content and testability for your APIs'
    },
    {
      'displayName': 'API Tester',
      'image': './assets/img/partnerOnboarding/tester.jpg',
      'description': 'Test your APIs and register them as well'
    },
    {
      'displayName': 'API Documentor',
      'image': './assets/img/partnerOnboarding/document.jpg',
      'description': 'Declaratively create your documentation for APIs'
    },
    {
      'displayName': 'HTML Documentor',
      'image': './assets/img/partnerOnboarding/html.jpg',
      'description': 'Create HTML content using WYSIWYG editor'
    }
  ];

  constructor() { }

  ngOnInit() {
    for (let i = 0; i < this.devExServicesPayload.length; i++) {
      for (let j = 0; j < this.devExUtilities.length; j++) {
        if (this.devExServicesPayload[i] === this.devExUtilities[j]['displayName']) {
          const id = 'selectedDevExUtility' + j;
          this.availableDevExServices.push(id);
        }
      }
    }

    const that = this;
    $(document).ready(function () {
      for (const id of that.availableDevExServices) {
        $('#' + id).addClass('selectedDevExService');
      }
    });
  }

  selectDevExUtility(index) {
    for (let i = 0; i < this.devExUtilities.length; i++) {
      const id = 'selectedDevExUtility' + i;
      if (index === i) {
        if ($('#' + id).hasClass('selectedUsageRequirements')) {
          $('#' + id).removeClass('selectedUsageRequirements');
          for (let j = 0; j < this.devExServicesPayload.length; j++) {
              if (this.devExUtilities[i]['displayName'] === this.devExServicesPayload[j]) {
                  this.devExServicesPayload.splice(j, 1);
              }
          }
        } else {
          $('#' + id).addClass('selectedUsageRequirements');
          this.devExServicesPayload.push(this.devExUtilities[i]['displayName']);
        }
      }
    }
  }

}
